import { PageMessage } from '../components/PageMessage'

export function AccessRevokedPage() {
  return (
    <PageMessage
      title="Access revoked"
      body="Your account has been deactivated in this application. Contact an administrator if you believe this is a mistake."
    />
  )
}
